import CartItemPrice from './CartItemPrice';
import CartRemove from './CartRemove';
import QuantitySelector from '../shared-components/QuantitySelector';
import cn from 'classnames';
import { formatMoney } from '@shopify/theme-currency';
import { getSizedImageUrl } from '@shopify/theme-images';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useState } from 'preact/hooks';

const CartItem = ({ item }) => {
  const [error, setError] = useState();

  return (
    <div>
      <div class="relative flex items-center">
        {item.featured_image && item.featured_image.url && (
          <div class="mr-3 w-20 md:mr-4 md:w-28">
            <a class="block aspect-product-item" href={item.url}>
              <img
                class="h-full w-full object-contain"
                alt={item.featured_image.alt}
                src={
                  getSizedImageUrl(item.featured_image.url, 'medium') ||
                  item.featured_image.url
                }
              />
            </a>
          </div>
        )}

        <div class="flex-1">
          <div class="flex items-center gap-4">
            <div class="flex-1">
              <a class="type-heading-5 block" href={item.url}>
                {item.product_title}
              </a>
              <p className="type-body-small mb-1">
                {!item.product_has_only_default_variant &&
                  item.options_with_values.map(
                    ({ name, value }, i) =>
                      name !== 'Region' && (
                        <span
                          className={cn({
                            "after:mx-2 after:content-['·']":
                              item.options_with_values.length - 1 > i,
                          })}
                        >
                          {value}
                        </span>
                      ),
                  )}
              </p>
              <div class="type-body-small">
                <p>{formatMoney(item.final_price, theme.moneyFormat)}</p>
                {item.compare_at_price > item.final_price && (
                  <p class="line-through opacity-60">
                    {formatMoney(item.compare_at_price, item.currency)}
                  </p>
                )}
              </div>

              {item.selling_plan_allocation && (
                <span class="type-text-8 my-1 inline-flex items-center bg-grey-4 px-2 py-1">
                  <SubscriptionIcon className="mr-1 size-5" />
                  {item.selling_plan_allocation.selling_plan.name}
                </span>
              )}

              {item.properties &&
                Object.entries(item.properties).map(
                  ([key, val]) =>
                    val &&
                    !key.startsWith('_') && (
                      <p className="type-text-8">
                        {key}:{' '}
                        {val.includes('/uploads/') ? (
                          <a href={val}>{val.split('/').pop()}</a>
                        ) : (
                          val
                        )}
                      </p>
                    ),
                )}
            </div>

            <div class="flex flex-col items-center gap-2 md:items-start">
              <div class="flex flex-col md:flex-row md:items-center md:gap-6">
                <QuantitySelector item={item} setError={setError} />
                <div class="hidden md:block">
                  <CartItemPrice item={item} />
                </div>
              </div>
              <div class="md:ml-9">
                <CartRemove item={item} />
              </div>
            </div>
          </div>

          {/* Discounts */}
          {item.line_level_discount_allocations.length > 0 && (
            <div class="mt-2 space-y-2">
              {Object.entries(item.line_level_discount_allocations).map(
                ([key, value]) => (
                  <div key={key} class="type-text-8">
                    {value.discount_application.title}
                  </div>
                ),
              )}
            </div>
          )}
        </div>

        {error && (
          <div class="type-text-8 absolute bottom-1 right-0 text-error">
            {getTranslation('cart.quantity_error', { quantity: error })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CartItem;
